import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';

const conditionalDef = {
  type: FgBlockType.Conditional,
  build: () => ({
    dataIn: [sockIn("condition", FgType.Boolean, false), sockIn("onTrue", FgType.Any), sockIn("onFalse", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const condition = getDataValue(ctx, env, block, "condition");
    const chosen = condition ? getDataValue(ctx, env, block, "onTrue") : getDataValue(ctx, env, block, "onFalse");
    setDataValue(ctx, block, "value", chosen);
  }
};

export { conditionalDef };
//# sourceMappingURL=conditional.js.map
